import { render } from "./LeadTimezoneBuffer.vue?vue&type=template&id=1f37dff3&scoped=true"
import script from "./LeadTimezoneBuffer.vue?vue&type=script&lang=js"
export * from "./LeadTimezoneBuffer.vue?vue&type=script&lang=js"

import "./LeadTimezoneBuffer.vue?vue&type=style&index=0&id=1f37dff3&scoped=true&lang=css"

import exportComponent from "/var/www/felipe_admin_sr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f37dff3"]])

export default __exports__